// extracted by mini-css-extract-plugin
module.exports = {"card":"BYTprICOODWCj90GKFjA","stats":"jBIRSP4WS3YJ5VJDP4QJ","warning":"Iwuy1amrnsxQeS6F3jMf"};